import { MapPin } from "lucide-react";
import { AREAS } from "@/data";
import { Reveal, Eyebrow } from "@/components/site/Reveal";

export default function AreasServed({ serviceName }) {
  return (
    <section
      data-testid="areas-section"
      className="border-t border-[#2a2a2a] bg-[#050505] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-12 max-w-3xl">
          <Reveal><Eyebrow>Where we work</Eyebrow></Reveal>
          <Reveal i={1}>
            <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.02] tracking-tighter text-[#f5f5f0] sm:text-5xl">
              {serviceName ? `${serviceName} across the region` : "Servicing regional Victoria & NSW"}
            </h2>
          </Reveal>
          <Reveal i={2}>
            <p className="mt-5 text-base leading-relaxed text-[#8a8a8a]">
              Based in Swan Hill, we attend planned and unplanned works within a
              350&nbsp;km radius — across regional Victoria, New South Wales and
              the South Australian border.
            </p>
          </Reveal>
        </div>

        <Reveal className="flex flex-wrap gap-2">
          {AREAS.map((town) => (
            <span
              key={town}
              className="group inline-flex items-center gap-2 border border-[#2a2a2a] px-4 py-2 text-sm text-[#f5f5f0] transition-colors duration-300 hover:border-[#c4a962] hover:text-[#c4a962]"
            >
              <MapPin className="h-3.5 w-3.5 text-[#c4a962]" />
              {town}
            </span>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
